// Ícone de informação (tooltip) reutilizável — explica, item a item, o
// que cada configuração de white label faz, para o operador superAdmin
// entender o efeito antes de alterá-la. Envolve o próprio
// TooltipProvider (espelha o padrão do theme-tab) para funcionar em
// qualquer tab sem depender de um provider global.
import { InfoIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"

type FieldInfoProps = {
  // Chave i18n da descrição do campo (ex.:
  // "pages.adminWhiteLabels.theme.descriptions.name").
  hintKey: string
}

export const FieldInfo = ({ hintKey }: FieldInfoProps) => {
  const { t } = useTranslation()
  // O texto resolvido vira também o aria-label (acessibilidade): quem
  // navega por leitor de tela ouve a explicação sem depender do hover.
  const hint = t(hintKey)

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <InfoIcon
            className="size-3.5 shrink-0 cursor-help text-muted-foreground"
            aria-label={hint}
          />
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs">
          {hint}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
